import React from "react";
import { industriesData } from "../data/mock";
import {
  Factory,
  Building2,
  Warehouse,
  HardHat,
  Heart,
  Landmark,
  ShoppingCart,
  GraduationCap,
} from "lucide-react";

const iconMap = {
  Factory,
  Building2,
  Warehouse,
  HardHat,
  Heart,
  Landmark,
  ShoppingCart,
  GraduationCap,
};

export const IndustriesSection = () => {
  return (
    <section className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-teal-500" />
            <span className="text-teal-700 text-sm font-semibold uppercase tracking-wider">
              Who We Serve
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Industries We Serve
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            From manufacturing plants to corporate offices, we serve diverse industries across Tamil Nadu.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
          {industriesData.map((industry, i) => {
            const Icon = iconMap[industry.icon];
            return (
              <div
                key={i}
                className="group bg-white rounded-2xl p-6 text-center border border-slate-100 hover:border-emerald-200 shadow-sm hover:shadow-lg hover:shadow-emerald-900/[0.05] transition-all duration-300 hover:-translate-y-1 cursor-default"
              >
                <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-100 transition-colors duration-300">
                  {Icon && (
                    <Icon className="w-6 h-6 text-emerald-700" />
                  )}
                </div>
                <span className="text-sm font-semibold text-slate-700 group-hover:text-emerald-800 transition-colors">
                  {industry.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
